import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getLeadsQueryKey } from "./utils";
import { getCompaniesOptions } from "../company/get-companies";

type LinkLeadCompanyInput =
  | { companyId: string; companyName?: never }
  | { companyName: string; companyId?: never };

const linkLeadCompany = async (
  organizationID: string,
  leadID: string,
  input: LinkLeadCompanyInput,
): Promise<void> => {
  const token = localStorage.getItem("profiletool-auth-token");
  const baseUrl =
    process.env.REACT_APP_BASE_URL ?? "https://profiletool-api.onrender.com";

  const response = await fetch(
    `${baseUrl}/v1/organizations/${organizationID}/leads/${leadID}/company`,
    {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(input),
    },
  );

  if (!response.ok) throw new Error("Failed to link company to lead");
};

export const useLinkLeadCompany = (organizationID: string, leadID: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: LinkLeadCompanyInput) =>
      linkLeadCompany(organizationID, leadID, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getLeadsQueryKey(organizationID) });
      queryClient.invalidateQueries({ queryKey: getCompaniesOptions(organizationID).queryKey });
    },
  });
};
